const getAbsoluteIndicatorValue = (id, indicatorDataPoint) => ({
  [id]: indicatorDataPoint.absolute,
});

export default getAbsoluteIndicatorValue;
